import script from "./SalesPerformanceChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesPerformanceChart.vue?vue&type=script&setup=true&lang=js"

import "./SalesPerformanceChart.vue?vue&type=style&index=0&id=04aadfb8&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04aadfb8"]])

export default __exports__